import type { SubscriptionActions } from '@store/reducers/subscription'

const buildDownload = (xhr: XMLHttpRequest, fileName: string) =>
  new Promise<void>((resolve, reject) => {
    xhr.onload = () => {
      const url = window.URL.createObjectURL(xhr.response)
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = fileName
      anchor.style.display = 'none'
      document.body.appendChild(anchor)
      setTimeout(() => {
        anchor.click()
        document.body.removeChild(anchor)
        setTimeout(() => {
          window.URL.revokeObjectURL(anchor.href)
          resolve()
        }, 250)
      }, 66)
    }
    xhr.onerror = reject
    xhr.send()
  })

const API_ROOT = import.meta.env.VITE_API_URL

export function* downloadInvoice({
  payload: { orderId },
}: ReturnType<typeof SubscriptionActions.downloadInvoice>) {
  const xhr = new XMLHttpRequest()
  xhr.open('GET', `${API_ROOT}/my/invoices/${orderId}`, true)
  xhr.responseType = 'blob'

  const token = localStorage.getItem('token')

  if (!token) {
    return
  }
  xhr.setRequestHeader('X-Auth-Token', token)

  const downloadPromise = buildDownload(xhr, `invoice-${orderId}.pdf`)

  yield downloadPromise
}
